<template>
  <div class="detail">
    <van-card>
      <template #title>
        <div class="card-title">{{ data.title }}</div>
      </template>
      <template #desc>
        <div class="card-introduce">{{ data.introduce }}</div>
      </template>
      <template #tags>
        <div class="card-time">
          <span v-if="data.createTime" style="float: left;">{{data.time}}
          </span>
          <div v-if="data.readNum" style="float: right;" class="">阅读：{{ data.readNum }}</div>
        </div>
      </template>
    </van-card>

    <div class="ql-editor">
      <div class="text" v-html="data.content"></div>
    </div>
  </div>
</template>

<script>
import {newsInfo} from '@api/contentNews'

export default {
  name: 'info',
  data() {
    return {
      id: '', // id
      data: {}
    }
  },
  mounted() {
    this.id = this.$route.query.id
    this.getInfo()
  },
  methods: {
    // 获取内容详情
    getInfo() {
      newsInfo({id:this.id}).then(res => {
        if (res.data.code === 200) {
          this.data = res.data.data
          this.data.content = this.data.content;
        } else {
          this.$toastMsg(res.data.msg)
        }
      })
    }
  }
}
</script>

<style scoped lang="scss">
@import "../../assets/css/mixin";

.detail {
  background-color: white;
  //height: 100%;

  .ql-editor {
    @include add_size($font_size_16);
    margin-bottom: 40px;
    background-color: white;
    padding-top: 0;
  }

  .van-card {
    background-color: white;
    border-top: 0.5px solid #EEEEEE;
  }

  .card-title {
    font-weight: bold;
    @include add_size($font_size_20);
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    overflow: hidden;
  }

  .card-time {
    @include add_size($font_size_14);
    color: #999999FF
  }

  .card-introduce {
    padding-bottom: 10px;
    @include add_size($font_size_16);
    padding-top: 10px;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    overflow: hidden;
  }
}

</style>
